<template>
  <div class="main">
    <PageHeader></PageHeader>
    <div class="container">

      <div class="title2">我的订单</div>

      <div class="keyWrap">
        <div class="items-wrap">
          <div class="table-wrap">
            <div class="li header">
              <div class="td" style="width: 40px;">序号</div>
              <div class="td" style="width: 100px;">订单号</div>
              <div class="td" style="width: 220px;">Key</div>
              <div class="td" style="width: 100px;">视频加速次数</div>
              <div class="td" style="width: 100px;">实付金额/元</div>
              <div class="td" style="width: 100px;">剩余加速次数</div>
              <div class="td" style="width: 120px;">适用平台</div>
              <div class="td" style="width: 170px;">订单时间</div>
              <div class="td" style="width: 190px;"  v-if="tableShowChangeCtx">操作</div>
              <div class="td" style="width: 170px;" v-if="isHasKey2">蓝猫浏览器激活码</div>
              <div class="td" style="width: 190px;" v-if="isShowSpecialTd">其它</div>
            </div>
            <div class="noData" v-show="!orderList.length">
              您还没订单
            </div>
            <div class="li" v-for="(item, index) in orderList" :key="index" v-if="orderList.length && canShow(item)">
              <div class="td" style="width: 40px;">{{ index + 1 }}</div>
              <div class="td" style="width: 100px;">{{ item.orderid }}</div>
              <div class="td" style="width: 220px;"
                :style="{ 'font-weight': item.toolkey ? 550 : 400, 'color': item.toolkey ? '#006eff' : '#606266' }">

                <span v-if="item.status == 2">
                  <span v-if="item.canuse == -1">分站开通成功</span>
                  <span v-else>{{ item.toolkey == '-' ? '审核通过' : item.toolkey }}</span>
                </span>

                <span v-if="item.status == 1 && !orderIs10Min(item)"
                  style="display: flex;align-items: center;justify-content: center;">审核中<svg t="1731638680290"
                    class="icon loading" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                    p-id="9571" width="200" height="200">
                    <path d="M520.64 239.44m-59.25 0a59.25 59.25 0 1 0 118.5 0 59.25 59.25 0 1 0-118.5 0Z" p-id="9572">
                    </path>
                    <path d="M316.6 321.37m-47.98 0a47.98 47.98 0 1 0 95.96 0 47.98 47.98 0 1 0-95.96 0Z" p-id="9573">
                    </path>
                    <path d="M232.3 521.59m-43.98 0a43.98 43.98 0 1 0 87.96 0 43.98 43.98 0 1 0-87.96 0Z" p-id="9574">
                    </path>
                    <path d="M316.6 726.13m-41.04 0a41.04 41.04 0 1 0 82.08 0 41.04 41.04 0 1 0-82.08 0Z" p-id="9575">
                    </path>
                    <path d="M520.64 806.53m-34.31 0a34.31 34.31 0 1 0 68.62 0 34.31 34.31 0 1 0-68.62 0Z" p-id="9576">
                    </path>
                    <path d="M723.43 726.13m-27.43 0a27.43 27.43 0 1 0 54.86 0 27.43 27.43 0 1 0-54.86 0Z" p-id="9577">
                    </path>
                    <path d="M808.03 522.78m-20.21 0a20.21 20.21 0 1 0 40.42 0 20.21 20.21 0 1 0-40.42 0Z" p-id="9578">
                    </path>
                    <path d="M724.29 318.88m-14.39 0a14.39 14.39 0 1 0 28.78 0 14.39 14.39 0 1 0-28.78 0Z" p-id="9579">
                    </path>
                  </svg></span>
                <span v-if="item.status == 1 && orderIs10Min(item)"
                  @click="isShowPayConfirm = true; curOrder = item"><span
                    style="font-weight: 500;color: #010;">手动获取，</span><span
                    style="cursor: pointer;color: #006eff;font-weight: 550;">查询</span></span>

                <span v-if="item.status == 2 && item.canuse != -1 && item.toolkey != '-'" class="copy"
                  @click="setClipdata(item.toolkey)">复制</span>
              </div>
              <div class="td" style="width: 100px;">{{ item.count }}</div>
              <div class="td" style="width: 100px;">{{ item.balance == 0 ? '-' : item.price }}</div>
              <div class="td" style="width: 100px;">{{ item.status == 1 ? '-' : item.balance }}</div>
              <div class="td special" style="width: 120px;">{{ transCanuse(item.canuse) }}</div>
              <div class="td" style="width: 170px;">{{ transformT(item.createtime) }}</div>
              <div class="td" style="width: 170px;font-weight: 550;color:#006eff;cursor: pointer;"
                @click="changeCtx(item)" v-if="tableShowChangeCtx">{{ item.isShowChangeCtx ? '更换平台' : '-' }}</div>
              <div class="td" style="width: 170px;" v-if="isHasKey2">{{ item.key2 || '-' }}</div>
              <div class="td specail2" style="width: 190px;" v-if="isShowSpecialTd">
                <div v-show="item.canShowOtherTd"><a
                    href="https://k16kfjgxwbn.feishu.cn/share/base/form/shrcneg70W5wHYaNEfbBUBk9vGh"
                    target="_blank">申请退款</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a
                    href="https://k16kfjgxwbn.feishu.cn/share/base/query/shrcnR7a78MRJtujQ4BvQ2aETjg"
                    target="_blank">退款查询</a></div>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
      <div class="payTip" v-if="orderList.length">订单为系统自动审核，最慢5-10分钟审核完成后刷新一下页面</div>

      <!--      <div class="section2">-->
      <!--        <div class="text1 title2">投诉建议 客服服务态度差，等其它问题</div>-->
      <!--        <div class="img-wrap">-->
      <!--          <img src="https://public.gaozhiwang.top/public/image/ctx/tousuwx.jpg" alt="">-->
      <!--        </div>-->
      <!--      </div>-->
    </div>


    <van-popup v-model="isShowPayConfirm" :style="{ background: 'transparent' }">
      <div class="warp">
        <div class="ipt-wrap">
          <input type="text" placeholder="输入 支付宝交易订单号" v-model="payOrderid">
        </div>
        <div class="submitBtn" @click="handleSearchOrderid">确认查询</div>
      </div>
    </van-popup>
    <van-popup v-model="showPicker" position="center" :style="{ width: '40%' }" round>
      <van-picker show-toolbar :columns="Internetcourse" @confirm="onConfirm" @cancel="showPicker = false"
        value-key="name" />
    </van-popup>
    <div class="kefu-wrap">
      <Kefu></Kefu>
    </div>
  </div>
</template>

<script>
import Kefu from "../components/kefu.vue";
import { Toast, Dialog } from 'vant';
import { handleGetCtxlist } from '@/utils/api/home'
import {
  handleGetOrder, handleGetOrderConfig, handleSearchOrderid, hanldUserChangCtxId
} from '@/utils/api/order'
export default {
  name: 'myorder',
  data() {
    return {
      showPicker: false,
      orderList: [],
      token: '',
      userinfo: '',
      Internetcourse: [],
      isShowSpecialTd: false,
      // 展示7天退款
      isShowAfterSalesService: false,
      isShowPayConfirm: false,
      payOrderid: '',
      curOrder: {},
      isHasKey2: false, // 是否有key2
      tableShowChangeCtx: false, // 是否展示切换ctx (7天内 且为 优学院)
      currentToolkey: '',
    }
  },
  components: {
    Kefu
  },
  computed: {
    transCanuse() {
      return function (id) {
        let result = ''
        if (id == '2037') {
          result = '全平台'
          return result
        }
        if (id == '-1') {
          result = '开通分站'
          return result
        }

        for (var k in this.Internetcourse) {
          if (this.Internetcourse[k].id == id) {
            result = this.Internetcourse[k].name
            return result
          }
        }
      }
    },
    canShow() {
      return function (item) {
        let result = true;
        let today = new Date().getTime();
        let orderT = new Date(item.createtime).getTime();
        if (((today - orderT) / 1000 / 60 / 60 / 24) > 7 && item.canuse == 2) {
          result = false
        }
        if (((today - orderT) / 1000 / 60 / 60 / 24) > 7 && item.status != 2) {
          result = false
        }
        if ((item.count - item.balance) < 10 && ((today - orderT) / 1000 / 60 / 60 / 24) > 10) {
          result = false
        }
        if (((today - orderT) / 1000 / 60 / 60 / 24) > 365) {
          result = false
        }
        if (parseInt(item.balance) < 1) {
          result = false
        }
        return result
      }
    },
    orderIs10Min() {
      return function (item) {
        let result = false;
        let today = new Date().getTime();
        let orderT = new Date(item.createtime).getTime();
        if (((today - orderT) / 1000) > 20) {
          result = true
        }
        return result
      }
    }
  },
  mounted() {
    this.token = localStorage.getItem('tooltoken');
    let _user = localStorage.getItem('userinfo');
    if (this.token && _user && _user != 'undefined') {
      this.getCtxlist()
      this.userinfo = JSON.parse(localStorage.getItem('userinfo'))
    }
  },
  methods: {
    onConfirm(value) {
      console.log(value);
      if(value.name === '优学院'){
        return alert('当前已经是优学院')
      }
      hanldUserChangCtxId({
        "toolkey": this.currentToolkey,
        "schoolname": value.name,
        "ctxid": value.id
      }).then(res => {
        alert(res.message)
        location.reload()
      })
    },
    changeCtx(item) {
      if (!item.isShowChangeCtx) return;
      this.currentToolkey = item.toolkey
      this.showPicker = true
    },
    handleSearchOrderid() {
      if (!this.payOrderid.trim()) {
        return alert('请输入订单号')
      }
      if (this.payOrderid.trim().length != 28) {
        return alert('支付宝交易订单号长度不正确')
      }
      handleSearchOrderid({
        payOrderid: this.payOrderid.trim(),
        ...this.curOrder
      }).then(res => {
        console.log(res);
        if (res.code === 200) {
          Dialog.alert({
            message: res.message,
          }).then(() => {
            location.reload()
          })
        } else {
          Dialog.alert({
            message: res.message,
          })
        }
      })
    },
    getCtxlist() {
      handleGetCtxlist().then(async res => {
        if (res.code == 200) {
          this.Internetcourse = res.result
        }

        handleGetOrderConfig(1).then(result => {
          this.isShowAfterSalesService = result.data;
        })

        this.getOrder()
      })
    },
    getOrder() {
      handleGetOrder().then(res => {
        if (res.code == 200) {
          let today = new Date().getTime();
          this.orderList = res.data;


          // this.isHasKey2 = this.orderList.some(item => item.key2);
          // if (this.isShowAfterSalesService) {
          //   this.orderList = this.orderList.map(item => {
          //     let obj = Object.assign({}, item);
          //     let orderT = new Date(item.createtime).getTime();
          //     if (((today - orderT) / 1000 / 60 / 60 / 24) < 7 && item.status == 2 && item.balance > (item.count - 11)) {
          //       obj.canShowOtherTd = true
          //       this.isShowSpecialTd = true
          //     }

          //     return obj
          //   })
          // }

          this.orderList = this.orderList.map(item => {
            let obj = Object.assign({}, item);
            if (item.key2) {
              this.isHasKey2 = true
            }
            let orderT = new Date(item.createtime).getTime();
            let is7Day = ((today - orderT) / 1000 / 60 / 60 / 24) < 7;
            if (this.isShowAfterSalesService) {
              if (is7Day && item.status == 2 && item.balance > (item.count - 11)) {
                obj.canShowOtherTd = true
                this.isShowSpecialTd = true
              }
            }
            if (is7Day && item.canuse === '2' && (item.balance > (item.count - 11))) {
              obj.isShowChangeCtx = true
              this.tableShowChangeCtx = true
            }

            return obj
          })
        }
        if (res.code == 403) {
          Toast.fail('登录已过期，请点击立即购买重新登录')
          localStorage.removeItem('tooltoken')
        }
      })
    },
    setClipdata(data) {
      try {
        navigator.clipboard.writeText(data);
        Toast.success('复制成功')
      } catch (e) {
        const textarea = document.createElement('textarea');
        textarea.setAttribute('readonly', 'readonly');
        textarea.value = data;
        document.body.appendChild(textarea);
        textarea.select();
        if (document.execCommand('copy')) {
          document.execCommand('copy');
          Toast.success('复制成功')
        }
        document.body.removeChild(textarea);
      }
    },
  }

}
</script>

<style scoped lang="less">
.main {
  width: 100%;
  height: 100vh;
  background-color: #fbfbfb;
}

.container {
  width: 1200px;
  min-height: 700px;
  margin: 0 auto;
  background-color: #fff;
  box-sizing: border-box;
  padding: 0 20px;
  padding-bottom: 200px;
  margin-top: 30px;
  padding-top: 10px;
}

.icon.loading {
  width: 27px;
  height: 27px;
  animation: rotate 1.5s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.title2 {
  font-weight: 550;
  margin-top: 0px;
  padding-left: 6px;
  border-left: 4px solid orange;

  span {
    font-size: 13px;
    font-weight: normal;
  }
}

.keyWrap {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 10px;
  color: #006eff;
  font-weight: 550;

  .copy {
    border: 1px solid rgba(0, 0, 0, .7);
    font-weight: 500;
    font-size: 14px;
    padding: 2px 5px;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 7px;
  }

  .copy:hover {
    background-color: #006eff;
    color: #fff;
  }



  .items-wrap {
    border: 1px solid #ebebeb;
    border-radius: 3px;
    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
    font-weight: 400;
    background-color: #fff;
    font-size: 14px;
    color: #606266;
    padding: 24px;
    width: 1200px;
    box-shadow: 0 0 9px rgba(0, 0, 0, .1);

    .table-wrap {
      border: 1px solid #ebebeb;

      .li.header {
        background-color: #f5f7fa;
        height: 40px;
      }

      .li {
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 35px;
        border-bottom: 1px solid #ebebeb;

        .td {
          text-align: center;
        }

        .td.special {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 13px;
        }

        .td.specail2 {
          a {
            color: #006eff;
            font-weight: 550;
          }
        }
      }
    }

  }
}

.kefu {
  margin-top: 10px;

  .kefu-li {
    font-size: 15px;
    margin-top: 5px;
    display: flex;
    align-items: center;

    img {
      width: 20px;
      height: 20px;
      margin-left: 5px;
    }

    span {
      color: #1d1818;
    }
  }
}

.noData {
  margin-top: 10px;
  text-align: center;
  line-height: 40px;
}

.payTip {
  color: #000;
  margin-bottom: 10px;
  margin-top: 20px;
  font-size: 14px;
  box-sizing: border-box;
  border-left: 4px solid rgb(255, 55, 0);
  background-color: #ff00001e;
  padding: 8px;
  border-radius: 5px;
}

.kefu-wrap {
  position: fixed;
  right: 30px;
  bottom: 100px;
  z-index: 999;
}

.section2 {
  .text1 {
    margin-bottom: 7px;
  }

  .img-wrap {
    border: 1px solid #a7a3a3;
    border-radius: 4px;
    width: 150px;
    box-shadow: 0 0 3px rgba(0, 0, 0, .1);

    img {
      width: 150px;
      height: 150px;
    }
  }
}

.warp {
  width: 500px;
  padding: 50px 30px;
  background-color: #fff;
  box-shadow: 0 0 9px rgba(0, 0, 0, .1);
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;

  .ipt-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    width: 95%;

    input {
      width: 100%;
      height: 40px;
      border: 1px solid #ebebeb;
      border-radius: 4px;
      padding: 0 10px;
      box-sizing: border-box;
    }
  }

  .submitBtn {
    width: 150px;
    height: 40px;
    background-color: #006eff;
    color: #fff;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    margin-top: 20px;
    text-align: center;
    line-height: 40px;
    box-shadow: 0 0 3px rgba(0, 0, 0, .1);
  }
}
</style>
